import templateTicketProjectStatusPicker from './ticketProjectStatusPicker.template.html';

/* @ngInject */

export default ($timeout) => {
  return {
    template: templateTicketProjectStatusPicker,
    restrict: 'E',
    scope: {
      status: '<',
      statuses: '<',
      onPick: '&'
    },
    controller: function ($scope, $element) {
      'ngInject';
      $scope.isMenuVisible = false;

      $scope.pickStatus = function (status) {
        $scope.status = status;
        if ($scope.onPick) {
          $scope.onPick({ status: status });
        }
        $scope.isMenuVisible = false;
      };

      $scope.showMenu = function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        $scope.isMenuVisible = true;
        $timeout(function () {
          $element.find('md-menu').find('button').triggerHandler('click');
        });
      };
    }
  };
};
